<template>
  <v-card>
    <v-btn absolute style="right: 10px; top: 10px" flat icon @click="$emit('close')" color="secondary">
      <v-icon>close</v-icon>
    </v-btn>
    <v-card-text v-if="promocao_model.url_imagem_promocao">
      <v-layout row wrap justify-center>
        <v-flex xs12 class="text-xs-center headline font-weight-light secondary--text mb-3">
          Pré-visualização do banner
        </v-flex>
        <v-flex xs8>
          <v-img :src="promocao_model.url_imagem_promocao" class="clickable"></v-img>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-text v-else>
      <v-layout row wrap justify-center>
        <v-flex xs12 class="text-xs-center headline font-weight-light secondary--text mb-3">
          Banner atual
        </v-flex>
        <v-flex xs8 v-if="promocao.url_imagem_promocao">
          <v-img :src="promocao.url_imagem_promocao"></v-img>
        </v-flex>
        <v-flex v-else class="text-xs-center subheading font-weight-light error--text mb-3">
          Você ainda não possui um banner cadastrado
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn flat block @click="$refs.input.click()" class="grey--text text--darken-1">
        CARREGAR IMAGEM
        <input
          type="file"
          style="display:none"
          accept="image/*"
          ref="input"
          @input="carregarImagem"
        />
      </v-btn>
    </v-card-actions>
    <v-card-actions>
      <v-btn flat block @click="promocao_model.url_imagem_promocao = '',$emit('close')" class="grey--text text--darken-1">CANCELAR</v-btn>
      <v-btn flat block color="success" @click="salvarBanner" :loading="loading">SALVAR E SAIR</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
window.EXIF = require('exif-js')

export default {
  props: ['promocao'],
  data () {
    return {
      promocao_model: {
        url_imagem_promocao: ''
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    carregarImagem (event) {
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onload = event => {
          var image = new Image()
          image.src = event.target.result
          var self = this
          image.onload = function () {
            var height = this.height
            var width = this.width
            if (height !== 500 || width !== 500) {
              alert('A imagem deve ter tamanho 500x500 pixels')
              return false
            }
            self.promocao_model.url_imagem_promocao = event.target.result
            return true
          }
        }
        reader.readAsDataURL(imagem)
      }
    },
    salvarBanner () {
      this.$store.dispatch('atualizarBannerPromocional', { cnpj: this.posto.cnpj, promocao: this.promocao.id, imagem: this.promocao_model.url_imagem_promocao }).then((bannerUrl) => {
        this.$emit('close', bannerUrl)
      })
    }
  }
}
</script>
